<div class="outer-border mt-5">
  <mat-table #table [dataSource]="dataSource" class="table">
    <ng-container matColumnDef="tipoComissao">
      <mat-header-cell *matHeaderCellDef>Tipo de comissão</mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="text-truncate">
          {{ row?.tipoComissao?.sigla | infoLabel }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="contato">
      <mat-header-cell *matHeaderCellDef>Contato</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.contato | infoLabel }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="telefone">
      <mat-header-cell *matHeaderCellDef>Telefone</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.telefone | telefone | infoLabel }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef>E-mail</mat-header-cell>
      <mat-cell *matCellDef="let row">
        {{ row.email | infoLabel }}
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let row" class="d-flex align-items-center pr-2 justify-content-end">
        <bdg-icon-button icon="edit" (click)="onClickEditarComissao(row)"></bdg-icon-button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  <div *ngIf="dataSource.data.length === 0" class="w-100 border-bottom text-center table-message white-background">
    <bdg-label color="rgba(0, 0, 0, 0.54); font-style: italic;">
      Nenhuma comissão encontrada para a instituição.
    </bdg-label>
  </div>

  <mat-paginator
    [length]="dataSource.data.length"
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]"
    class="mat-paginator-comissao"
  ></mat-paginator>
</div>
<div class="w-100" style="height: 1em"></div>
